import { render, staticRenderFns } from "./fullGiftClassification.vue?vue&type=template&id=3f29a8fd&scoped=true"
import script from "./fullGiftClassification.vue?vue&type=script&lang=js"
export * from "./fullGiftClassification.vue?vue&type=script&lang=js"
import style0 from "./fullGiftClassification.vue?vue&type=style&index=0&id=3f29a8fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f29a8fd",
  null
  
)

export default component.exports